import { Pipe, PipeTransform, inject } from "@angular/core";
import {
  AbilityAction,
  AbilitySubject,
  UserService
} from "src/app/services/user.service";

@Pipe({
  name: "can",
  standalone: false
})
export class CanPipe implements PipeTransform {
  private readonly userService = inject(UserService);

  transform(
    action: AbilityAction,
    subject: AbilitySubject,
    conditions?: Record<string, string>
  ) {
    return this.userService.able(action, subject, conditions);
  }
}
